import React from 'react';

import { useScreenState } from '@gogame/screens';

import { FILTER_TITLES } from 'scenes/Trackers/HourlyTracker/constants';
import { useLoadFilterDetails } from 'scenes/Trackers/HourlyTracker/data/useLoadFilterDetails';
import WidgetFilters from 'scenes/Trackers/components/Widget/WidgetFilters';

const getFilterTitle = (id) => FILTER_TITLES[id];

const HourlyTrackerPresetFilters = () => {
  const { filtersCollection } = useScreenState();

  const { data, isLoading } = useLoadFilterDetails({
    filters: filtersCollection,
  });

  const compareMode = filtersCollection?.length > 1;

  return (
    <WidgetFilters
      data={data}
      isLoading={isLoading}
      compareMode={compareMode}
      getFilterTitle={getFilterTitle}
    />
  );
};

export default HourlyTrackerPresetFilters;
